const information = {
  path: 'information',
  component: resolve => require(['../../../../../../pages/admin/merchant/signing/information'], resolve),
}

export default information
